
  import React from "react"
  import Component from "/home/runner/work/web.ivm-meyer/web.ivm-meyer/src/templates/layout.index.js"
  import data from "/home/runner/work/web.ivm-meyer/web.ivm-meyer/.cache/json/layout-layout-verwaltung.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/layout-verwaltung.js